import React, { FC, useState, useEffect } from 'react';
import IconButton from 'src/components/atoms/buttons/IconButton';
import { hintModalViewStore } from 'src/store/modal';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import Parse from 'html-react-parser';
import _ from 'lodash';
import './style.scss';

interface Props {}

/**
 * Modal 확인 창 레이아웃
 */
const ModalHintLayout: FC<Props> = () => {
  const modalData = hintModalViewStore((state: any) => state.data);
  const setHintModalState = hintModalViewStore((state: any) => state.set);
  const closeEvt = () => {
    setHintModalState({
      active: '',
      content: null,
    });
  };
  const content = modalData.content || '';
  return (
    <div className={['_modal_hint_content_layout', modalData.active].join(' ')}>
      <div className="_bg_box" onClick={closeEvt} />
      <div className="_content_box">
        <div className="_content_set" style={modalData.styleDef}>
          <div className="_condtent_div">
            <div className="_top">
              <div className="_label">
                <i className="ri-question-line" />
              </div>
              <div className="_tit">{modalData.title || ''}</div>
            </div>
            <div className="_content ">{Parse(content)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalHintLayout;
